// extracted by mini-css-extract-plugin
var _1 = "AuthInvalidHash-modulehelpText__SUT0J AuthHelpText-moduleAuthHelpText__HX0rS";
var _2 = "AuthInvalidHash-moduletitle__acs80 AuthTitle-moduleAuthTitle__VKaTa";
export { _1 as "helpText", _2 as "title" }
